function required(message = 'Field is required') {
    return function required(value) {
        if (!value) {
            return message;
        }
        return null; // succesfully passed validation
    }
}
function fileRequired(message ="File is required"){
    return function(value){
        if ( value?.name == ''){
            return message
        }
        return null; // succesfully passed validation
    }
}
function idDomain(message = 'Not a valid domain') {
    return function idDomain(value) {
        const re = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/;
        if (!re.test(value)) {
            return message;
        }
        return null; // succesfully passed validation
    }
}
function isLowerCase(message = 'Field cannot contain uppercase characters') {
    return function isLowerCase(value) {
        const re = /[A-Z]/;
        if (re.test(value)) {
            return message;
        }
        return null; // succesfully passed validation
    }
}

function minLength(minLen, message = `Field minimum length is ${minLen}`) {
    return function minLength(value) {
        if (value == null || value.length < minLen) {
            return message;
        };
        return null; // succesfully passed validation
    };
}
function exists(func, message = `'${value}' Already Exists`) {
    return async function exists(value) {
        if (!value || value.trim() == "") {
            return //{ exists: { error: true, message: 'Field cannot be empty', value } };
        }
        // execute api call that check value for existance 
        // - must return empty array (not exists) or array of values (exists)
        const data = await func(value)
        if (data.length) {
            return message;
        }
        return null; // succesfully passed validation
    };
}

function isNumber(message = undefined) {
    return function isNumber(value) {
        let isNumber = null; // succesfully passed validation

        // don't also make it required
        if (value === undefined || value === '') {
            return false
        }

        if (typeof value != "string") {
            isNumber = !isNaN(value);
        }
        else {
            isNumber = !isNaN(value) && !isNaN(parseFloat(value));
        }
        if (isNumber) {
            return null; // succesfully passed validation
        }
        else {
            return 'Field is not a number';
        }
    }
}

export default {
    required,
    minLength,
    isNumber,
    idDomain,
    exists,
    isLowerCase,
    fileRequired
};